<template>
  <section v-if="links" class="side-bar">
    <img
      @click="closeSideBar"
      class="side-bar__cross"
      src="../assets/images/cross.svg"
    />
    <ul class="side-bar__mobile-container">
      <li @click="authenticate" class="side-bar__mobile-container--links">
        {{ loginText }}
      </li>
    </ul>
    <ul class="side-bar__container" @click="closeSideBar">
      <li
        v-for="(link, i) in links"
        :key="i"
        class="side-bar__container--links"
        v-scroll-to="{
          el: `#${link.scroll}`,
          duration: 500,
          lazy: false,
          easing: 'linear',
        }"
      >
        {{ link.name }}
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'SideBar',
  props: {
    links: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  computed: {
    loginText() {
      return this.authState.isAuthenticated ? 'Sign out' : 'Sign in'
    },
  },
  methods: {
    authenticate() {
      return this.authState.isAuthenticated ? this.logout() : this.login()
    },
    login() {
      this.$auth.signInWithRedirect()
    },
    async logout() {
      // await this.$auth.signOut()
      localStorage.removeItem('okta-token-storage')
      this.$router.push('/')
    },
    closeSideBar() {
      this.$emit('closeSideBar', false)
    },
  },
}
</script>

<style lang="scss">
$desktop: 1024px;
$tablet: 768px;
$mobile: 600px;

.side-bar {
  background-color: var(--color-cupcake-1);
  width: 30%;
  position: fixed;
  height: 400vh;
  z-index: 999999;
  @media (max-width: $tablet) {
    width: 100%;
    position: fixed;
  }
  &__cross {
    display: none;
    @media (max-width: $tablet) {
      display: block;
      margin-left: 85%;
      margin-top: 40px;
    }
  }
  &__container,
  &__mobile-container {
    list-style: none;
    color: var(--color-charcoal-1);
    margin: 40px 0;
    &--links {
      font-weight: 600;
      font-size: 28px;
      margin: 10px 0;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
  }
  &__mobile-container {
    display: none;
    border-bottom: 2px solid var(--color-charcoal-1);
    border-top: 2px solid var(--color-charcoal-1);
    padding: 40px;
    @media (max-width: $tablet) {
      display: block;
    }
  }
}
</style>